export default __webpack_public_path__ + "static/students1-6a4ab2d2a6aead77e5998aac5a06255b.jpg";